import Axios, {AxiosResponse} from "axios";
import RootApi from "./root-api";

export default class CategoryApi extends RootApi {
    private readonly apiEndpoint: string = `${this.ApiRoot}/categories`;

    public async getCategories(): Promise<AxiosResponse> {
        return await Axios.get(`${this.apiEndpoint}`);
    }
}



// WEBPACK FOOTER //
// ./src/api/category-api.ts